module.exports = __webpack_public_path__ + "img/04.edbe3237.png";